<template>
    <div
        ref="mountRef"
        :class="className"
        :style="style"
        class="aurora-mount"
        aria-hidden="true"
    ></div>
</template>

<script setup lang="ts">
    import {
        onMounted,
        onBeforeUnmount,
        useTemplateRef,
        type CSSProperties,
    } from "vue";
    import { useAuroraStage } from "@/composables/useAuroraStage";

    // Props kept for backwards compatibility with existing call sites.
    // The singleton AuroraStage controls actual rendering parameters.
    interface AuroraProps {
        colorStops?: string[];
        amplitude?: number;
        blend?: number;
        time?: number;
        speed?: number;
        intensity?: number;
        noiseIntensity?: number;
        className?: string;
        style?: CSSProperties;
        resolutionScale?: number;
    }

    withDefaults(defineProps<AuroraProps>(), {
        className: "",
        style: () => ({}),
    });

    const mountRef = useTemplateRef<HTMLDivElement>("mountRef");
    const { register, unregister } = useAuroraStage();

    onMounted(() => {
        if (mountRef.value) {
            register(mountRef.value);
        }
    });

    onBeforeUnmount(() => {
        if (mountRef.value) {
            unregister(mountRef.value);
        }
    });
</script>

<style scoped>
    .aurora-mount {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: none;
    }
</style>
